var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 100 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x82\x90\xEC\x82\x90\xEB\xA1\x9C\xEA\xB3\xA0",
    clipPath: "url(#clip0_144_1556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.2878 19.2034L20.4898 6.62115C22.4451 0.656456 29.1605 -1.17296 33.8727 3.03594C36.2939 5.19873 39.7276 8.66308 41.8474 11.1204C44.3069 13.9707 45.1332 17.7726 43.8232 21.3773C43.0011 23.6373 40.8512 25.7223 39.1727 27.4059C38.5136 28.0671 37.697 28.6838 37.0667 29.402L32.3709 24.7458L23.7618 33.4942L30.1238 40.0423L69.1394 0.486984C69.7615 0.00497489 70.426 -0.156158 71.1646 0.174442L97.9921 27.2378C101.847 31.8593 99.9008 38.6879 94.2994 40.534L81.877 42.8079C81.7591 42.8843 81.6276 43.5233 81.5892 43.7095C80.8493 47.3363 80.5232 51.223 79.6874 54.804C78.1239 61.5035 70.0917 63.526 65.6125 58.435L51.5937 44.1276L62.9871 32.5566L67.6829 37.2128L76.3125 28.4852L69.8862 22.0704L31.0884 61.3174C29.6141 62.7342 28.4713 61.6799 27.334 60.5603C18.7715 52.1245 10.6283 43.19 2.0192 34.7847C-1.9654 30.041 0.24339 23.0317 6.06819 21.4106L18.2878 19.202L18.2878 19.2034Z",
    fill: "var(--fill-0, #EEE0AF)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_1556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/logo-login.a08f47d7ff3f067939102408e1246ef2.svg";
export { ForwardRef as ReactComponent };